import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=5173249e&scoped=true&"
import script from "./BasePagination.vue?vue&type=script&lang=ts&"
export * from "./BasePagination.vue?vue&type=script&lang=ts&"
import style0 from "./BasePagination.vue?vue&type=style&index=0&id=5173249e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173249e",
  null
  
)

export default component.exports